<template>
  <!--srcviewscompanydetailsvuehtmlStart-->
  <!-- 详情 -->
  <div
    id="defaultId1"
    class="uIo8QCo"
    name="header"
    ref="scrollContainer"
    @scroll="handleScroll"
  >
    <content_view v-if="!Compare" id="gc95c2" ref="contentView">
      <template id="ce3846" slot="header">
        <div id="cdd8de" class="uVNPU6H">
          <tools
            id="c46180"
            class="u35ff8"
            :UpdateStatus="UpdateStatus"
            :config="toolsConfig"
            @clickMenu="clickMenu"
            ref="tools"
          >
          </tools>
        </div>
      </template>

      <template id="c3b8e6" slot="details_view">
        <div
          id="g30b5a"
          :class="
            markList.length > 8
              ? 'trade_com_top ud2d4026'
              : 'ud2d40 trade_com_top'
          "
        >
          <div id="ga36b2" class="c u4f5b">
            <div style="display: flex; align-items: center">
              <div id="g4fdd2" class="uc4421">
                <div class="uc4421_text">
                  {{ company == null ? "" : company?.base?.companyName }}
                </div>
              </div>
              <svg
                t="1728813835525"
                v-if="company?.base?.collectIds != '-'"
                class="icon icon24"
                viewBox="0 0 1075 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="12745"
              >
                <path
                  d="M273.757233 1023.872016a111.269069 111.269069 0 0 1-65.092533-21.142915 108.632604 108.632604 0 0 1-44.000812-107.378363l36.091416-208.459925c2.815642-16.074759-2.559675-32.379888-14.282986-43.591264l-0.102387-0.127984-152.863786-147.718839a108.58141 108.58141 0 0 1-28.054037-112.44652 109.835651 109.835651 0 0 1 89.358251-74.768104l211.249971-30.306551A49.836871 49.836871 0 0 0 343.610761 250.85019l94.477602-189.646315A110.168409 110.168409 0 0 1 537.454943 0.002048c42.413813 0 80.578567 23.421026 99.340984 61.227424l94.452005 189.646315c7.218283 14.48776 21.245302 24.624073 37.576027 27.055764l211.249972 30.434535a110.040425 110.040425 0 0 1 89.486235 74.742507 108.325443 108.325443 0 0 1-28.054037 112.472116l-152.863787 147.590856a49.504113 49.504113 0 0 0-14.385373 43.719248l36.091417 208.357538a108.607007 108.607007 0 0 1-44.128796 107.378363 110.731537 110.731537 0 0 1-116.541999 8.318944l-188.955203-98.445098a49.862467 49.862467 0 0 0-46.330116 0l-188.929606 98.445098a110.321989 110.321989 0 0 1-51.705433 12.926358z"
                  :fill="
                    company?.base?.collectIds == '-' ? '#006B9B' : '#FF6A6A'
                  "
                  p-id="12746"
                ></path>
              </svg>
            </div>
            <div id="gb2142" class="u7bd96">
              <div id="g77a65" class="u0e1f6">
                <img
                  id="gf2e43"
                  class="uc6a2b"
                  :src="company?.base?.img"
                  alt=""
                />
                <div id="g767ad" class="ubb08b">
                  <span> {{ company?.base?.city }}</span
                  ><span v-if="company?.base?.province"> , </span
                  ><span> {{ company?.base?.province }}</span
                  ><span v-if="company?.base?.country"> , </span
                  ><span> {{ company?.base?.country }}</span>
                </div>
              </div>
            </div>
            <el-tabs
              v-model="activeLabelTab"
              class="detail_header_info_label trade_top_tab_list"
            >
              <el-tab-pane
                :key="index"
                v-for="(item, index) in markList"
                :label="item.label"
                :name="item.label"
                :disabled="true"
              >
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="new-content-top-right">
            <div class="new-content-right-company">
              <div ref="companyRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CompanyDQI") }}
                <el-tooltip
                  class="item"
                  effect="light"
                  popper-class="detail-dqi-tips"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CompanyDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CompanyTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc2") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc3") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="new-content-right-country">
              <div ref="countryRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CountryDQI") }}
                <el-tooltip
                  class="item"
                  effect="light"
                  popper-class="detail-dqi-tips"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CountryDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CountryTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc2") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div id="g29da1" class="trade_bottom_cont">
          <div id="g06fa7" class="ue896e">
            <ul id="ga9199" class="ufb44d">
              <div id="g251bf"></div>
              <li
                id="ga557d"
                @click="openUrl(item, '')"
                v-for="(item, index) in breadcrumbBar"
                :key="index"
                v-show="item.isShow"
                :class="tab1ActiveName == item.id ? 'bread_active' : ''"
                class="trade_tab_item"
              >
                <div
                  class="textu99b63"
                  :class="tab1ActiveName == item.id ? 'bread_active2' : ''"
                >
                  {{ item.screenName }}
                </div>
              </li>
            </ul>
          </div>
          <div id="g599f6" v-show="isShowMoreMarkLable" class="u2ac23 mb10">
            <div
              id="gfff13"
              class="u8bb4e"
              v-if="markTotalList.length > 0"
              :class="[isNoShowTab2 != 'showMark' ? 'mt0' : 'mt0']"
            >
              <div v-for="(item, index) in markTotalList" :key="index">
                <gui_mark_total
                  :MoudeImg="'images/tradejiugonge.png'"
                  id="g9eda6"
                  class="u661e6"
                  :label="item.name"
                  :total="item.num"
                  v-if="item.num != '-'"
                >
                </gui_mark_total>
              </div>
            </div>
          </div>
          <div class="back-to-top" v-show="showBackToTop" @click="scrollToTop">
            <button class="showBackToTop">
              <svg
                t="1732090638802"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6153"
                width="20"
                height="20"
              >
                <path
                  d="M564.4 213.7C549.9 199.2 530.9 192 512 192c-19 0-38 7.2-52.5 21.7L73.4 599.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l361.3-361V928c0 17.7 14.3 32 32 32s32-14.3 32-32V283.7l361.4 361c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L564.4 213.7zM96 129l832-1c17.7 0 32-14.4 32-32 0-17.7-14.3-32-32-32L96 65c-17.7 0-32 14.4-32 32 0 17.7 14.3 32 32 32z"
                  p-id="6154"
                  fill="#FFFFFF"
                ></path>
              </svg>
            </button>
          </div>

          <div id="g1e372" class="u0c804">
            <router-view
              :companyBaseRoute="company"
              id="cb02bf"
              @UpdatamarkTotalList="childUpdatamarkTotalList"
            >
            </router-view>
          </div>
        </div>
      </template>
    </content_view>
    <Suo
      :suoClose="Update"
      @closeCloseDialog="clossuoDialog($event)"
      @closeCloseDialog1="clossuoDialog1($event)"
      :ComapnyName="company?.base?.companyName"
    ></Suo>
    <div style="width: 100%" v-if="Compare">
      <compareCompanys
        :compareList="compareList"
        @CompareShowfalse="CompareShow($event)"
      ></compareCompanys>
    </div>
    <Reporterror
      :showReport="ReportError"
      :companynameen="companyName"
      :Company="company"
      @closeReportDialog="closeDialog($event)"
      :powerStatus="powerToReportErrorStatus"
    ></Reporterror>

    <el-dialog
      :visible.sync="hasPrivilege"
      center
      :close-on-click-modal="true"
      @close="chasPrivilegeDialog"
      custom-class="dialog_normalsuo dialog_normalpower"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center">
            <img
              class="powerdengpao"
              src="@/assets/images/powerdengpao.png"
              alt=""
            />
          </div>
          <div class="detail_cont_text">
            The feature you’re attempting to access is part of our premium
            membership benefits. To gain access to this feature and enjoy full
            access to premium features, please subscribe to our membership plan.
          </div>
        </div>
      </div>
      <div class="flex_center">
        <el-button
          class="btn_export btn_exportCCC"
          @click="hasPrivilege = false"
          >OK</el-button
        >
        <el-button
          class="btn_export"
          @click="
            $router.push({
              path: '/index/addCredit',
            })
          "
          >Subscribe</el-button
        >
      </div>
    </el-dialog>
    <PermissionDialog></PermissionDialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import PermissionDialog from "@/components/power/PermissionDialog.vue";
import { mixins1 } from "@/mixins/index";
import content_view from "../layout/content_view.vue";
import gui_tabs from "../../components/gui_tabs/gui_tabs.vue";
import gui_tab_item from "../../components/gui_tabs/gui_tab_item.vue";
import gui_collapse from "../../components/gui_collapse/gui_collapse.vue";
import gui_checkbox from "../../components/gui_checkbox/gui_checkbox.vue";
import gui_scroll_x from "../../components/gui_scroll_x/gui_scroll_x.vue";
import gui_link_content from "../../components/gui_link_content/gui_link_content.vue";
import { goAnchor, GetQueryString } from "../../utils/anchor.js";
import * as echarts from "echarts/core";
import { getCompanySnap, searchTradeGridData } from "@/api/companyApi.js";
import gui_mark_total from "../../components/gui_mark_total/gui_mark_total.vue";
import tools from "@/views/layout/tools.vue";
import Suo from "./list/UpdateDialog.vue";
import Reporterror from "./list/detailreportError.vue";
import compareCompanys from "./list/detailecompareCompanys";
import ReLogin from "../../components/ReLogin.vue";
//importEnd
import {
  downloadOnlinePdf,
  gettabList,
  whetherDeductPoints,
  getTabListOneLayer,
} from "@/api/userApi";
export default {
  name: "",
  mixins: [mixins1],
  props: {},
  watch: {
    $route(to, from) {
      // 在路由变化时执行的代码
      if (to.name == "businessActivitiesimport&Export") {
        this.tab2ActiveName = to.query.idpower;
      }
    },
  },
  mounted() {
    this.$store.state.app.toolsConfig.creditAssessment.isShow = false;
    this.$store.state.app.toolsConfig.dataAnalysis.isShow = false;
    this.$store.state.app.toolsConfig.customPortfolio.isShow = false;
    this.$store.state.app.toolsConfig.print.isShow = false;
    this.$store.state.app.toolsConfig.riskScanning.isShow = false;
    this.gettabList();
    this.setThemeColor();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    document.title = this.$route.query.companyName;
  },
  created() {
    this.getCompanySnaplist();
    window.addEventListener("scroll", this.handleScroll);
    this.whetherDeductPointsDetail();
  },
  beforeUnmount() {
    // 移除页面滚动事件的监听
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  active() {},

  components: {
    PermissionDialog,
    Suo,
    Reporterror,
    compareCompanys,
    tools,
    gui_mark_total,
    content_view,
    gui_tabs,
    gui_tab_item,
    gui_collapse,
    gui_checkbox,
    gui_scroll_x,
    gui_link_content,
    ReLogin,
  },

  data() {
    return {
      DQihovershowInfo: false,
      DQihovershowInfoTwo: false,
      showBackToTop: false,
      reLoginVis: false,
      companyName: "",
      UpdateStatus: 0,
      Compare: false,
      ReportError: false,
      powerToReportErrorStatus: false,
      Update: false,
      Download: false,
      hasPrivilege: false,
      randomKey: this.getRandomInt(1, 100), //
      // insertData
      // srcviewscompanydetailsvueDataStart

      // option2
      company: null,
      compareList: [],
      option2: {},
      // option1

      // isShowMenu
      isShowMenu: true,
      // cascader6Props
      cascader6Props: {
        expandTrigger: "click",
        multiple: true,
        checkStrictly: false,
        emitPath: true,
        lazy: false,
        lazyLoad: () => {},
        value: "value",
        label: "label",
        children: "children",
        disabled: "disabled",
        leaf: "leaf",
        hoverThreshold: 500,
      },
      // sort_listProps
      sort_listProps: {
        expandTrigger: "click",
        multiple: true,
        checkStrictly: false,
        emitPath: true,
        lazy: false,
        lazyLoad: () => {},
        value: "value",
        label: "label",
        children: "children",
        disabled: "disabled",
        leaf: "leaf",
        hoverThreshold: 500,
      },
      // toolsConfig
      toolsConfig: {
        menu: {
          isShow: true,
          isActive: false,
        },

        filter: {
          isShow: false,
          isActive: false,
        },

        select: {
          isShow: true,
          isActive: false,
        },

        edit: {
          isShow: true,
          isActive: false,
        },

        sort: {
          isShow: true,
          isActive: false,
        },

        collect: {
          isShow: true,
          isActive: false,
        },

        saved: {
          isShow: true,
          isActive: false,
        },

        compare: {
          isShow: true,
          isActive: false,
        },

        export: {
          isShow: true,
          isActive: false,
        },

        download: {
          isShow: true,
          isActive: false,
        },

        update: {
          isShow: true,
          isActive: false,
        },

        reportError: {
          isShow: true,
          isActive: false,
        },

        riskScanning: {
          isShow: true,
          isActive: false,
        },
        creditAssessment: {
          isShow: true,
          isActive: false,
        },
        dataAnalysis: {
          isShow: true,
          isActive: false,
        },
        customPortfolio: {
          isShow: true,
          isActive: false,
        },
        print: {
          isShow: true,
          isActive: false,
        },
        share: {
          isShow: true,
          isActive: false,
        },
      },
      // star
      star: false,
      // isShowMoreMark
      isShowMoreMark: false,
      // markList
      activeLabelTab: "",
      markList: [],
      breadcrumbBar: [],
      // tab1ActiveName
      tab1ActiveName: "Business Activities",
      // isNoShowTab2
      isNoShowTab2: false,
      hasPrivilege: false,
      isShowMoreMarkLable: false,
      // 背景样式
      tab2BkStyle: {
        width: "",
        height: "",
        left: "",
        top: "",
        display: "block",
      },
      // tab2_list
      tab2_list: ["Snapshot", "Profile", "Ownership"],
      // tab2ActiveName
      tab2ActiveName: "Snapshot",
      markTotalList: [],
      lineHeight: 28,
      py: "55%",
      companyDQI: 0, //公司值
      countryDQI: 0, //国家值
      companyChart: null,
      countryChart: null,
      // srcviewscompanydetailsvueDataEnd
    };
  },
  methods: {
    handleScroll() {
      // 判断页面滚动距离是否超过200px，更新showBackToTop的值
      const scrollTop = this.$refs.scrollContainer.scrollTop;
      this.showBackToTop = scrollTop > 390;
    },
    scrollToTop() {
      const container = this.$refs.scrollContainer; // 使用 ref 获取容器
      container.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    whetherDeductPointsDetail() {
      if (this.$route.query.id3a) {
        whetherDeductPoints({
          companyAaaid: this.$route.query.id3a,
        }).then((res) => {
          this.UpdateStatus = res.data.status;
          if (this.UpdateStatus == 6 || this.UpdateStatus == 2) {
            this.toolsConfig.update.isActive = false;
          }
        });
      }
    },
    gettabList() {
      getTabListOneLayer({
        aaaId: this.$route.query.id3a,
        moduleType: 9,
      }).then((res) => {
        let routerName = this.$route.name;

        if (res.code == 200) {
          this.breadcrumbBar = res.data;
          let moduleId =
            res.data.find((item) => routerName.includes(item.name))?.id || null;
          this.tab1ActiveName = moduleId;
          if (moduleId) {
            getTabListOneLayer({
              aaaId: this.$route.query.id3a,
              moduleId: moduleId,
            }).then((res) => {
              this.tab2_list = res.data;
              let tab2ActiveName =
                res.data.find((item) => routerName.includes(item.name))?.id ||
                null;
              this.tab2ActiveName = tab2ActiveName;
            });
          }
          let arr = [];
          res.data.map((item, index) => {
            if (item.name == "competitivenessandCreditEvaluation") {
              arr.push({
                id: item.name,
                name: item.screenName,
                children:
                  item.name == "competitivenessandCreditEvaluation"
                    ? [{ name: "tab2", id: "list" }]
                    : [
                        {
                          name: "tab2",
                          id: "list",
                          children: [],
                        },
                      ],
                isShow: item.isShow,
                hasPrivilege: true,
                isNoShowTab2:
                  item.name == "competitivenessandCreditEvaluation" ? "noShowAll" : "showMark",
              });
            } else {
            }
          });
        }
      });
    },
    //关闭report弹窗
    closeDialog(value) {
      this.ReportError = value;
    },
    chasPrivilegeDialog() {
      this.hasPrivilege = false;
    },
    clossuoDialog(value) {
      this.Update = value;
    },
    clossuoDialog1(value) {},
    CompareShow(val) {
      this.Compare = false;
    },

    childUpdatamarkTotalList(value) {
      this.isShowMoreMarkLable = value;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    setid(row) {
      if (row.includes("http")) {
        let routeData = row;
        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row;
        window.open(routeData, "_blank");
      }
    },

    // insertMethod
    // srcviewscompanydetailsvueMethodStart
    // initTab
    getCompanySnaplist() {
      const id3a = this.$route.query.id3a;
      getCompanySnap({
        id3a: id3a,
      })
        .then((res) => {
          this.company = res.data;
          this.companyName = res.data.base.companyName;
          let countryImg = this.getCountryImgUrl(res.data.base.countryFlag);
          this.company.base.img = require("../../../static" + countryImg);
          localStorage.setItem("CompanyBase", JSON.stringify(res.data));
          this.companyDQI =
            res.data.base.companyDQI != "n.a." &&
            res.data.base.companyDQI != "-"
              ? parseInt(res.data.base.companyDQI)
              : 0;
          this.initCompanyEchart();
          this.countryDQI =
            res.data.base.countryDQI && res.data.base.countryDQI != "-"
              ? parseInt(res.data.base.countryDQI)
              : 0;
          this.initCountryEchart();
          this.markList = res.data.labels;
          // tab 左右切换按钮状态 修复 通过监听 tab滑动style变化来触发状态更新***********
          this.$nextTick(() => {
            const nav = this.$el.querySelector(".el-tabs__nav");
            if (!nav) return;
            let syncing = false;
            this.observer = new MutationObserver(() => {
              if (syncing) return;
              syncing = true;
              const cur = this.activeLabelTab;
              this.activeLabelTab = "__temp__";
              this.$nextTick(() => {
                this.activeLabelTab = cur;
                syncing = false;
              });
            });
            this.observer.observe(nav, {
              attributes: true,
              attributeFilter: ["style"],
            });
          });
          // ***********************************************************************
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });

      searchTradeGridData({
        aaaid: id3a,
      })
        .then((res) => {
          if (res.code == 200) {
            this.markTotalList = [
              {
                name: "Import Amount",
                num: res.data.importAmount,
              },
              {
                name: "Export Amount",
                num: res.data.exportAmount,
              },
              {
                name: "Number of imports",
                num: res.data.numberOfImports,
              },
              {
                name: "Number of exports",
                num: res.data.numberOfExports,
              },
              {
                name: "Number of sellers",
                num: res.data.numberOfSellers,
              },
              {
                name: "Number of buyers",
                num: res.data.numberOfBuyers,
              },
              {
                name: "Number of origins",
                num: res.data.numberOfOrigins,
              },
              {
                name: "Number of destinations",
                num: res.data.numberOfDestinations,
              },
              {
                name: "Number of imported products",
                num: res.data.numberOfImportedProducts,
              },
              {
                name: "Number of exported products",
                num: res.data.numberOfExportedProducts,
              },
            ];
          } else {
            this.markTotalList = [
              {
                name: "Import Amount",
                num: "",
              },
              {
                name: "Export Amount",
                num: "",
              },
              {
                name: "Number of imports",
                num: "",
              },
              {
                name: "Number of exports",
                num: "",
              },
              {
                name: "Number of sellers",
                num: "",
              },
              {
                name: "Number of buyers",
                num: "",
              },
              {
                name: "Number of origins",
                num: "",
              },
              {
                name: "Number of destinations",
                num: "",
              },
              {
                name: "Number of imported products",
                num: "",
              },
              {
                name: "Number of exported products",
                num: "",
              },
            ];
            console.log(this.markTotalList);
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    // 公司echarts
    initCompanyEchart() {
      this.companyChart = echarts.init(this.$refs.companyRef);
      let data = this.companyDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: data == 100 ? [5, 5, 5, 5] : [5, 0, 5, 0],
                },
              },
              {
                value: 100 - data,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: data == 0 ? [5, 5, 5, 5] : [0, 5, 0, 5],
                },
              },
            ],
          },
        ],
      };
      this.companyChart.setOption(option);
    },
    // 国家echarts
    initCountryEchart() {
      this.countryChart = echarts.init(this.$refs.countryRef);
      let data = this.countryDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: data == 100 ? [5, 5, 5, 5] : [5, 0, 5, 0],
                },
              },
              {
                value: 100 - data,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: data == 0 ? [5, 5, 5, 5] : [0, 5, 0, 5],
                },
              },
            ],
          },
        ],
      };
      this.countryChart.setOption(option);
    },
    resizeChart() {
      // 调用 ECharts 实例的 resize 方法，动态调整图表大小
      if (this.companyChart) {
        this.companyChart.resize();
      }
      if (this.countryChart) {
        this.countryChart.resize();
      }
    },
    handleResize() {
      if (window.innerWidth > 1920) {
        // 大屏幕
        this.radiusX1 = 48;
        this.radiusX2 = 62;
        this.fontSize = 26;
        this.lineHeight = 28;
        this.py = "55%";
      } else {
        this.radiusX1 = 32;
        this.radiusX2 = 41;
        this.fontSize = 16;
        this.lineHeight = 18;
        this.py = "52%";
      }
      this.initCompanyEchart();
      this.initCountryEchart();
      this.resizeChart();
    },
    initTab() {
      let routes = {};
      this.breadcrumbBar.forEach((item) => {
        item.children.forEach((item2) => {
          let obj = {
            tab1: item.id,
            tab2: item2.id,
            isNoShowTab2: item.isNoShowTab2,
            tab2List: item.children,
          };
          routes[item.id + item2.id] = obj;
        });
      });

      let routerName = this.$route.name;

      this.tab1ActiveName = routes[routerName].tab1;
      this.tab2ActiveName = routes[routerName].tab2;
      this.tab2_list = routes[routerName].tab2List;

      let markTotal = this.tab2_list.find(
        (item) => item.id == this.tab2ActiveName,
      );

      let isNoShowTab2 = routes[routerName].isNoShowTab2;

      if (isNoShowTab2) {
        this.isNoShowTab2 = isNoShowTab2;
      } else {
        this.isNoShowTab2 = false;
      }
    },

    // clickMenu 控制详情
    clickMenu(name, data) {
      console.log(`name`, name);
      switch (name) {
        case "menu":
          this.$store.dispatch("app/toggleMenu", !this.$store.state.app.isMenu);
          break;
        case "select":
          this.$nextTick(() => {
            if (this.$refs.route.isOpenSlct) {
              this.$refs.route.isOpenSlct = false;
              this.$refs.route.isOpenSlct = false;
            } else {
              this.$refs.route.isOpenSlct = "Select";
              this.$refs.route.isOpenSlct = "Select";
            }
          });
          break;
        case "Update":
          this.Update = true;

          break;
        case "download":
          this.Download = true;
          downloadOnlinePdf(this.$route.query.id3a)
            .then((res) => {
              const binaryData = [];
              binaryData.push(res);
              let pdfUrl = window.URL.createObjectURL(
                new Blob(binaryData, { type: "application/pdf" }),
              );
              window.open(pdfUrl, "_blank");
            })
            .catch((err) => {
              this.reLoginVis = String(err).includes("403");
            });
          break;

        case "Compare":
          this.$nextTick(() => {
            if (this.$refs.route.Compare) {
              this.$refs.route.Compare = false;
            } else {
              this.$refs.route.Compare = true;
            }
          });
          break;

        case "Report":
          this.ReportError = true;
          this.powerToReportErrorStatus = true;
          break;

        case "edit":
          break;
      }
    },

    // toggleMoreMark
    toggleMoreMark() {
      this.isShowMoreMark = !this.isShowMoreMark;
    }, // openUrl
    openUrl(tab1Name, tab2Name) {
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;
      let SACode1 = "";
      newscountry.map((item) => {
        if (item.countryCode == this.company.base.countryFlag) {
          SACode1 = item.dowjonesCountrycode;
        }
      });

      if (tab1Name?.hasPrivilege || tab2Name?.hasPrivilege) {
        if (!tab1Name) {
          let tab1NameVal = this.breadcrumbBar.find(
            (item) => item.id == this.tab1ActiveName,
          )?.name;
          let tab2NameVal = tab2Name.name;
          this.tab2ActiveName = tab2Name.id;

          this.$router.push({
            name: tab1NameVal + tab2NameVal,
            params: {
              id: this.$route.params.id,
              idpower: tab2Name?.id,
            },
            query: {
              id3a: this.$route.query.id3a,
              companyCountry: this.company.base.countryFlag,
              SACode1: SACode1,
              idpower: tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
              companyName: this.$route.query.companyName,
              Tradechannel: this.$route.query.Tradechannel,
              Moudles: "Trade",
            },
          });
        } else {
          this.tab1ActiveName = tab1Name?.id;
          getTabListOneLayer({
            aaaId: this.$route.query.id3a,
            moduleId: tab1Name?.id,
          }).then((res) => {
            if (res.data.length > 0) {
              this.tab2_list = res.data.filter((item) => item.isShow == true);
              if (this.tab2_list.length > 0) {
                this.isNoShowTab2 = "";
                this.tab2ActiveName = this.tab2_list[0]?.id;
                this.$router.push({
                  name: tab1Name.name + this.tab2_list[0]?.name,
                  params: {
                    id: this.$route.params.id,
                    idpower: tab2Name?.id,
                  },
                  query: {
                    id3a: this.$route.query.id3a,
                    companyCountry: this.company.base.countryFlag,
                    SACode1: SACode1,
                    idpower:
                      tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
                    companyName: this.$route.query.companyName,
                    Tradechannel: this.$route.query.Tradechannel,
                    Moudles: "Trade",
                  },
                });
              }
            } else {
              this.$router.push({
                name: tab1Name.name,
                params: {
                  id: this.$route.params.id,
                  idpower: tab2Name?.id,
                },
                query: {
                  id3a: this.$route.query.id3a,
                  companyCountry: this.$route.query.companyCountry,

                  SACode1: SACode1,
                  idpower:
                    tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
                  companyName: this.$route.query.companyName,
                  Moudles: "Trade",
                  Tradechannel: this.$route.query.Tradechannel,
                },
              });
            }
          });
        }
      } else {
        this.hasPrivilege = true;
      }
    }, // 离开悬浮
    leaveTab2(event) {
      this.tab2BkStyle.display = `none`;
    }, // 悬浮tab2监听
    overTab2(e) {
      let event = e;
      const rect = event.target.getBoundingClientRect();
      const parentRect = event.target.parentNode.getBoundingClientRect();
      this.tab2BkStyle.width = `${rect.width}px`;
      this.tab2BkStyle.height = `${rect.height}px`;
      this.tab2BkStyle.left = `${rect.left - parentRect.left}px`;
      this.tab2BkStyle.top = `${rect.top - parentRect.top}px`;
      this.tab2BkStyle.display = `block`;
    }, // setThemeColor
    setThemeColor() {
      this.$store.dispatch("app/setThemColor", "#009EA7");
      this.$store.dispatch("app/setSearchType", "TradeDetail");
    },
    // srcviewscompanydetailsvueMethodEnd
  },
  computed: {},
  beforeDestroy() {
    // 页面销毁时 解除监听tab切换*************************************************
    this.observer && this.observer.disconnect();
    // *************************************************************************
  },
};
</script>
<style>
.uIo8QCo {
  display: flex;
  justify-content: center;
  overflow-y: hidden;
}

.uVNPU6H {
  width: 100%;
}

.u35ff8 {
  width: 100%;
  overflow: hidden;
}

.trade_com_top {
  display: flex;
  height: 310px;
  width: 100%;
  padding-top: 20px;
  padding-left: 70px;
  padding-right: 70px;
  padding-bottom: 146px;
  justify-content: space-between;
  gap: 30px;
  background-color: #009ea7;
}

.u4f5b {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 14px;
  overflow: hidden;
  border-color: rgb(172, 201, 24);
  color: rgb(255, 255, 255);
}

.uc4421 {
  color: rgb(255, 255, 255);
  margin-top: 0rem;
  margin-bottom: 0rem;
  margin-left: 0rem;
  margin-right: 0rem;
  padding-top: 0rem;
  padding-left: 0rem;
  padding-right: 0rem;
  padding-bottom: 0rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.uc4421_text {
  font-size: 36px;
  line-height: 40px;
  font-family: "Arial Bold";
  overflow: hidden;
  text-overflow: ellipsis;
}
.icon24 {
  width: 24px;
  height: 24px;
  margin-left: 40px;
}

.u0e1f6 {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.uc6a2b {
  width: 36px;
  height: 22px;
  margin-right: 10px;
}

.ubb08b {
  color: rgb(255, 255, 255);
  font-size: 18px;
  font-family: "Arial Regular";
  height: auto;
  overflow-y: auto;
  min-width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.u5b01d {
  color: rgb(255, 255, 255);
  font-size: 1.285714rem;
}

.u83191 {
  display: flex;
  flex: auto;
  margin-top: 0.8571428571428571rem;
}
.uboa8Fv {
  display: flex;
}

.u07ca9 {
  display: inline-block;
  margin-left: -1.4rem;
  margin-right: 1.4285714285714286rem;
  box-sizing: content-box;
}

.u61637 {
  border-color: rgb(53, 24, 201);
  overflow-y: auto;
}

.u91cf9 {
  display: inline-block;
  border: 1px solid rgb(255, 255, 255);
  padding: 6px;
  color: rgb(255, 255, 255);
  margin-right: 8px;
  margin-bottom: 6px;
  border-radius: 5px;
}

.u9KBSet {
  transform: rotate(1deg);
}
.new-content-top-right {
  min-width: 326px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.new-content-right-company,
.new-content-right-country {
  width: 124px;
  height: auto;
}
.new-content-right-echart {
  width: 100%;
  height: 62px;
  margin-bottom: 8px;
}
.new-content-right-title {
  display: flex;
  align-items: center;
  line-height: 20px;
  font-size: 16px;
  color: #ffffff;
  white-space: nowrap;
}
.new-content-right-title i {
  margin-left: 6px;
  font-size: 20px;
  color: #ffdb01;
  cursor: pointer;
}

.u1c1b4 {
  width: 50%;
  height: 200px;
}

.u0304c {
  width: 50%;
  height: 200px;
}

.trade_bottom_cont {
  margin-top: -100px;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  z-index: 99;
}

.ue896e {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: -0.21428571428571427rem;
}

.ufb44d {
  display: flex;
  flex-direction: row;
  text-align: center;
}

.trade_tab_item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  color: rgb(255, 255, 255);
  margin-right: 14px;
  line-height: 22px;
  padding: 14px 20px 10px;
  background-color: #32b1b8;
  text-align: center;
  border-radius: 10px 10px 0px 0px;
  box-sizing: border-box;
  cursor: pointer;
}

.textu99b63 {
  font-size: 18px;
}

.trade_tab_item:last-child {
  margin-right: 0;
}

.bread_active {
  background-color: rgb(255, 255, 255);
}

.bread_active2 {
  font-family: "Arial Bold" !important;
  color: #009ea7;
}

.u2ac23 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  padding: 20px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.udea11 {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 0.35rem 1.42rem;
  position: relative;
  border-bottom-left-radius: 0.28rem;
  border-top-left-radius: 0.28rem;
  border-top-right-radius: 0.28rem;
  border-bottom-right-radius: 0.28rem;
}

.u518ac {
  background-color: rgba(255, 255, 255, 1);
  position: absolute;
  border-top-left-radius: 0.28rem;
  border-bottom-left-radius: 0.28rem;
  border-top-right-radius: 0.28rem;
  transition: 0.4s;
  z-index: 0;
  pointer-events: none;
}

.uebc34 {
  margin-right: 1.4285714285714286rem;
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  font-size: 1.285714rem;
  border-bottom-left-radius: 0.2857142857142857rem;
  border-top-left-radius: 0.2857142857142857rem;
  border-top-right-radius: 0.2857142857142857rem;
  border-bottom-right-radius: 0.2857142857142857rem;
  z-index: 5;
}

.uebc34:last-child {
  margin-right: 0;
  /* 最后一个元素的 margin 为 0 */
}

.tab2_active {
  background-color: rgb(255, 255, 255);
  z-index: 10;
  font-weight: 400;
  font-family: "Arial Bold";
}

.u8bb4e {
  display: flex;
}

.u661e6 {
  margin-right: 5px;
  margin-left: 5px;
  height: 100%;
}

.u0c804 {
  border-radius: 5px;
}

.uboa8Fv .submore {
  height: 76px;
  overflow-y: auto;
  margin-right: 30px;
}

.submore::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
}

.u91cf9:nth-child(5n + 5) {
  color: #ffffff;
  border: 1px solid #ffb02b;
}

.u91cf9:nth-child(5n + 4) {
  color: #ffffff;
  border: 1px solid #00f1ff;
}

.u91cf9:nth-child(5n + 3) {
  color: #ffffff;
  border: 1px solid #5aff4a;
}

.u91cf9:nth-child(5n + 2) {
  color: #ffffff;
  border: 1px solid #ff8ecb;
}
.u0a580 .subsvg {
  transform: rotate(180deg);
}

.back-to-top {
  z-index: 99999;
  position: fixed;
  transition: opacity 0.4s ease-in-out 0s;
  opacity: 1;
  box-sizing: border-box;
  bottom: 150px;
  right: 25px;
  cursor: pointer;
}

.showBackToTop {
  width: 40px;
  height: 40px;
  background: #009ea7;
  border-radius: 50%;
  box-shadow: 0px 2px 10px 0px rgba(0, 122, 177, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail_header_info_label.trade_top_tab_list .el-icon-arrow-left,
.detail_header_info_label.trade_top_tab_list .el-tabs__nav-next {
  color: #009ea7;
}
.detail-dqi-tips {
  width: 540px;
  height: auto;
  padding: 20px !important;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

.html-new-page .el-tooltip__popper.detail-dqi-tips {
  transform: translateY(-2px);
}

.detail-dqi-tips .detail-dqi-tips-header {
  margin-bottom: 20px;
  line-height: 26px;
  font-family: "Arial Bold";
  font-size: 24px;
  color: #1a2332;
}

.detail-dqi-tips .detail-dqi-tips-desc {
  margin-bottom: 14px;
  line-height: 26px;
  font-size: 18px;
  color: #29445d;
}

.detail-dqi-tips .detail-dqi-tips-sub-desc {
  line-height: 22px;
}
.u7bd96 {
  margin-top: 10px;
  margin-bottom: 10px;
}
@media (max-width: 1920px) {
  .trade_com_top {
    height: 230px;
    padding-top: 15px;
    padding-left: 52px;
    padding-right: 52px;
    padding-bottom: 100px;
    gap: 24px;
  }
  .u4f5b {
    gap: 12px;
  }
  .new-content-top-right {
    margin-top: 7px;
    min-width: 218px;
  }
  .uboa8Fv .submore {
    height: 66px;
  }

  .ubb08b,
  .u5b01d,
  .textu99b63,
  .uebc34 {
    font-size: 16px;
  }
  .trade_bottom_cont {
    margin-top: -90px;
    margin-left: 15px;
    margin-right: 15px;
  }
  .trade_tab_item {
    margin-right: 10px;
    line-height: 18px;
    padding: 10px 15px 7px;
  }

  .uc4421_text {
    font-size: 28px;
    line-height: 30px;
  }

  .icon24 {
    width: 18px;
    height: 18px;
    margin-left: 30px;
  }

  .uc6a2b {
    width: 32px;
    height: 20px;
  }
  .u91cf9 {
    padding: 5px;
    margin-bottom: 5px;
  }
  .u2ac23 {
    padding: 15px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }
  .new-content-right-company,
  .new-content-right-country {
    width: 82px;
  }
  .new-content-right-echart {
    height: 42px;
    margin-bottom: 6px;
  }
  .new-content-right-title {
    line-height: 14px;
    font-size: 12px;
  }
  .new-content-right-title i {
    margin-left: 4px;
    font-size: 14px;
  }
  .new-content-detail-wrap {
    top: 168px;
    padding: 0 14px;
  }
  .detail-dqi-tips {
    width: 360px;
    padding: 14px !important;
    border-radius: 3px;
  }

  .html-new-page .el-tooltip__popper.detail-dqi-tips {
    transform: translateY(-2px);
  }

  .detail-dqi-tips .detail-dqi-tips-header {
    margin-bottom: 14px;
    line-height: 24px;
    font-size: 20px;
  }

  .detail-dqi-tips .detail-dqi-tips-desc {
    margin-bottom: 8px;
    line-height: 20px;
    font-size: 16px;
  }

  .detail-dqi-tips .detail-dqi-tips-sub-desc {
    line-height: 16px;
  }
  .u7bd96 {
    margin-top: 7px;
    margin-bottom: 7px;
  }
}
@media screen and (max-width: 1439px) {
  .trade_com_top {
    height: 220px;
    padding-top: 12px;
    padding-left: 46px;
    padding-right: 46px;
  }

  .uboa8Fv .submore {
    height: 60px;
  }

  .ubb08b,
  .u5b01d,
  .textu99b63,
  .uebc34 {
    font-size: 14px;
  }
  .trade_bottom_cont {
    margin-left: 13px;
    margin-right: 13px;
  }
  .trade_tab_item {
    margin-right: 10px;
    line-height: 16px;
    padding: 9px 13px 6px;
  }

  .uc4421_text {
    font-size: 28px;
  }
  .icon24 {
    width: 16px;
    height: 16px;
    margin-left: 26px;
  }

  .uc6a2b {
    width: 28px;
    height: 18px;
  }

  .u91cf9 {
    padding: 4px;
    margin-bottom: 4px;
  }
  .u2ac23 {
    padding: 12px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }
}
</style>
